import Airtable from 'airtable'
import sha256 from 'js-sha256'

Airtable.configure({
    endpointUrl: process.env.REACT_APP_AIRTABLE_ENDPOINT_URL,
    apiKey: process.env.REACT_APP_AIRTABLE_API_KEY
})

const base = Airtable.base(process.env.REACT_APP_AIRTABLE_BASE_ID)
const scoreSubmitTable = base(process.env.REACT_APP_AIRTABLE_SCORE_TABLE_ID)
const scorePublicTable = base(process.env.REACT_APP_AIRTABLE_PUBLIC_SCORE_TABLE_ID)
const statsTable = base(process.env.REACT_APP_AIRTABLE_STATS_TABLE_ID)

// Gets all the total games
export const getStats = async () => {
    const results = await statsTable.select({
        view: "Public view",
        fields: ["name", "value"],
     }).all()
    return results.map(r => ({
        ...r.fields,
        datetime: r._rawJson.createdTime
    }))
}

// Gets all the games of a player by his email address (secured with hash)
export const getPlayerGames = async ( email, game ) => {
    const hash = sha256( email )
    const results = await scorePublicTable.select({
        sort: [{
            field: "score",
            direction: "desc",
        }],
        // maxRecords: 20,
        view: "Public view",
        filterByFormula: `AND({email_hash} = '${hash}', {game_type} = '${game}')`,
        fields: ["score"]
    }).all()
    return results.map(r => ({
        ...r.fields,
        datetime: r._rawJson.createdTime
    }))
}

// Submits a score
export const submitScore = async (game, email, score, abbrevName = '') => {
    const result = await scoreSubmitTable.create({
        email,
        email_hash: sha256( email ),
        game_type: game,
        score,
        alias: abbrevName,
        include_in_newsletter: localStorage.getItem( 'includeNewsletter' ),
    })
    return {
        ...result.fields,
        datetime: result._rawJson.createdTime
    }
}

// Gets the leaderboard of a game
export const getLeaderBoard = async (game) => {
    const results = await scorePublicTable.select({
        sort: [{
            field: "score",
            direction: game === 'MEMORY_BLOCK' ? "asc" : "desc",
        }],
        maxRecords: 500,
        view: "Public view",
        filterByFormula: `{game_type} = '${game}'`,
        fields: ["id",  "alias", "game_type", "email_hash", "score"]
    }).all()
    
    return results.map(r => ({
        ...r.fields,
        datetime: r._rawJson.createdTime
    }))
}